<template>
  <v-app-bar id="toolbar" app clipped-left>
    <show-request-access
      v-model="selectedRequestAccess"
      @close="selectedRequestAccess = null"
    ></show-request-access>
    <edit-rate
      v-model="selectedVisit"
      @cancel="selectedVisit = null"
      @save="selectedVisit = null"
    ></edit-rate>
    <inform-pending-rates
      v-if="
        informPendingRates &&
          ($store.state.auth.user.roles[0] ==
          $store.state.constants.roles.ADMIN ||
          $store.state.auth.user.roles[0] ==
          $store.state.constants.roles.USER)
      "
      :show="informPendingRates"
      :logout="informPendingRatesLogout"
      @close="logout(true)"
      @cancel="informPendingRates = false"
      @openPendingRates="openPendingRates()"
    ></inform-pending-rates>

    <v-app-bar-nav-icon
      ref="drawerToggleBtn"
      v-if="
        $store.state.auth.user.roles[0] != $store.state.constants.roles.SECURITY
      "
      @click.stop="toggleDrawer()"
    ></v-app-bar-nav-icon>
    <admin-change-password v-model="changePasswordData"></admin-change-password>

    <!--
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    -->
    <v-toolbar-title>
      <img src="/images/logo.png" width="35%" style="padding-top: 10px" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-title> Contratados
     <!-- {{ title }} {{ $store.state.auth.user.company.name }} -->
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-menu
        z-index="105"
        :close-on-content-click="false"
        bottom
        left
        offset-y
        :disabled="pendingApprovalsCount == 0"
        v-if="
          $store.state.auth.user.roles[0] ==
          $store.state.constants.roles.SYS_ADMIN ||
          $store.state.auth.user.roles[0] ==
          $store.state.constants.roles.SYS_SUPERVISOR
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
            :disabled="pendingApprovalsCount == 0"
          >
            <v-badge color="error" overlap :value="pendingApprovalsCount != 0">
              <span slot="badge">{{ pendingApprovalsCount }}</span>
              <v-icon color="primary">notifications</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <notification-pending-approvals
          :items="pendingApprovalsItems"
        ></notification-pending-approvals>
      </v-menu>
      <v-menu
        z-index="105"
        bottom
        left
        offset-y
        :disabled="pendingRatesCount == 0"
        v-if="
          [ $store.state.constants.roles.ADMIN,
            $store.state.constants.roles.USER
          ].indexOf($store.state.auth.user.roles[0]) != -1
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
            :class="{ 'shake-alert': pendingRatesCount > 0 }"
            :disabled="pendingRatesCount == 0"
            ref="pendingRatesButton"
          >
            <v-badge color="error" overlap :value="pendingRatesCount != 0">
              <span slot="badge">{{ pendingRatesCount }}</span>
              <v-icon color="primary">star</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <notification-pending-rates
          @selectVisit="selectedVisit = $event"
          v-if="pendingRatesCount > 0"
          :items="pendingRatesItems"
        ></notification-pending-rates>
      </v-menu>
      <v-menu
        z-index="105"
        bottom
        left
        offset-y
        :disabled="requestAccessesCount == 0"
        v-if="
          [ $store.state.constants.roles.ADMIN,
            $store.state.constants.roles.USER
          ].indexOf($store.state.auth.user.roles[0]) != -1
        "
        v-model="forceMountAtStart"
      >
       <template v-slot:activator="{ on }">
        <v-btn
          text
          v-on="on"
          :class="{ 'shake-alert': requestAccessesCount > 0 }"
          :disabled="requestAccessesCount == 0"
        >
          <v-badge color="error" overlap :value="requestAccessesCount != 0">
            <span slot="badge">{{ requestAccessesCount }}</span>
            <v-icon color="primary">notifications</v-icon>
          </v-badge>
        </v-btn>
       </template>
       <notification-request-access
         :title="resx.labels.requestAccess"
         :isAdmin="true"
         @selectRequestAccess="selectedRequestAccess = $event"
         @updateRequestAccessesCount="updateRequestAccessesCount($event)"
         :items="requestAccessesItems"
       ></notification-request-access>

      </v-menu>
      <v-menu
        z-index="105"
        bottom
        left
        offset-y
        :close-on-content-click="false"
        :disabled="approvalsCount == 0"
        v-if="
          $store.state.constants.roles.SECURITY ==
          $store.state.auth.user.roles[0]
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
            :class="{ 'shake-alert': !wasSeen && approvalsCount > 0 }"
            :disabled="approvalsCount == 0"
            @click="wasSeen = true"
          >
            <v-badge color="error" overlap :value="!wasSeen && approvalsCount > 0">
              <span slot="badge" v-if="!wasSeen && approvalsCount > 0">{{ approvalsUnread }}</span>
              <v-icon color="primary">notifications</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <notification-request-access
          :title="resx.labels.accessAuthorizations"
          :isAdmin="false"
          @selectRequestAccess="selectedRequestAccess = $event"
          v-if="approvalsCount > 0"
          :items="approvalsItems"
        ></notification-request-access>

      </v-menu>
      <v-menu z-index="105" bottom left offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <v-avatar size="48">
              <v-icon large color="primary">account_circle</v-icon>
            </v-avatar>
            <span v-if="$vuetify.breakpoint.smAndUp">{{
              $store.state.auth.user.fullname
            }}</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="changePassword()">
            <v-list-item-action>
              <v-icon color="primary">security</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{
              resx.labels.changePassword
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-action>
              <v-icon color="primary">exit_to_app</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ resx.labels.logout }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
"use strict";

import { mapState } from "vuex";
import store from "@/store/store";

import {
  default as adminChangePassword,
  mixin as adminChangePasswordMixin
} from "@/components/views/users/admin-change-password.view.vue";
import editRate from "@/components/views/rates/edit-rate.view.vue";
import informPendingRates from "@/components/views/notifications/pending-rates/inform-pending-rates.view.vue";
import notificationPendingRates from "@/components/views/notifications/pending-rates/notification-pending-rates.view.vue";
import notificationPendingApprovals from "@/components/views/notifications/pending-approvals/notification-pending-approvals.view.vue";
import notificationRequestAccess from "@/components/views/notifications/request-access/notification-request-access.view.vue";
import showRequestAccess from "@/components/views/notifications/request-access/show-request-access.view.vue";

export default {
  components: {
    adminChangePassword,
    editRate,
    informPendingRates,
    notificationPendingRates,
    notificationPendingApprovals,
    notificationRequestAccess,
    showRequestAccess
  },
  mounted() {
    this.forceMountAtStart = false
  },
  computed: {
    ...mapState({
      pendingRatesCount: state => state.notifications.pendingRates.totalCount,
      pendingRatesItems: state => state.notifications.pendingRates.items,
      pendingApprovalsCount: state =>
        state.notifications.pendingApprovals.totalCount,
      pendingApprovalsItems: state =>
        state.notifications.pendingApprovals.items,
      requestAccessesItems: state => state.notifications.requestAccess.items,
      approvalsCount: state => state.notifications.approvals.totalCount,
      approvalsUnread: state => state.notifications.approvals.unread,
      approvalsItems: state => state.notifications.approvals.items,
      refreshVisits: state => state.refreshes.activateRefresh.refreshed
    })
  },
  data() {
    return {
      drawer: true,
      informPendingRates: false,
      informPendingRatesLogout: false,
      wasSeen: false,
      selectedRequestAccess: null,
      selectedVisit: null,
      title: store.state.config.appName,
      forceMountAtStart: true,
      requestAccessesCount: 0
    };
  },
  methods: {
    toggleDrawer() {
      this.$emit("input", !this.value);
    },
    logout(force = false) {
      if (
        this.$store.state.auth.user.roles[0] !=
          this.$store.state.constants.roles.ADMIN &&
        this.$store.state.auth.user.roles[0] !=
          this.$store.state.constants.roles.USER
      ) {
        force = true;
      }
      this.informPendingRatesLogout = true;
      this.informPendingRates = true;
      if (!force && this.$store.state.notifications.pendingRates.totalCount) {
        this.informPendingRatesLogout = true;
        this.informPendingRates = true;
      } else {
        try {
          this.$store.commit("logout");
          this.$store.commit("disconnect");
          this.$router.replace({ name: "login" });
        } catch (err) {
          console.error(err);
        }
      }
    },
    changePassword() {
      let user = this.$store.state.auth.user;
      user._id = user.id;
      this.changePasswordOpen(user);
    },
    openPendingRates() {
      this.informPendingRates = false;
      this.$refs.pendingRatesButton.$el.click();
    },
    updateRequestAccessesCount(count) {
      this.requestAccessesCount = count;
    }
  },
  mixins: [adminChangePasswordMixin],
  props: ["value"],
  watch: {
    approvalsItems() {
      var self = this;
      self.wasSeen = true;
      setTimeout(function() {
        self.wasSeen = false;
      }, 100);
    },
  }
};
</script>

<style sopped>
.shake-alert {
  animation: shake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  5%,
  15%,
  25%,
  35%,
  45%,
  55%,
  65%,
  75%,
  85%,
  95% {
    transform: translate3d(20px, 0, 0);
  }

  10%,
  20%,
  30%,
  40%,
  50%,
  60%,
  70%,
  80%,
  90% {
    transform: translate3d(-20px, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

#toolbar .v-toolbar__items .v-btn {
  width: max-content;
}
.v-toolbar__title {
  overflow: inherit;
}
</style>
